import type { Reducer } from 'redux';
import { produce } from 'immer';
import type { DeleteUserActions } from './types/actions.types';
import { defaultState, Fields } from './data/DeleteUserState';
import DeleteUserConstants from './constants';

const reducer: Reducer<Fields, DeleteUserActions> = (state = defaultState, action) => {
  return produce<Fields>(state, (draft) => {
    switch (action.type) {
      case DeleteUserConstants.OPEN_DELETE_USER_MODAL:
        draft.isModalOpen = true;
        draft.user = action.user;
        return draft;

      case DeleteUserConstants.CLOSE_DELETE_USER_MODAL:
        draft.isModalOpen = false;
        delete draft.user;
        delete draft.error;
        return draft;

      case DeleteUserConstants.DELETE_USER_REQUEST:
        draft.isLoading = true;
        delete draft.error;
        return draft;

      case DeleteUserConstants.DELETE_USER_REQUEST_SUCCESS:
        draft.isLoading = false;
        draft.isSuccess = true;
        return draft;

      case DeleteUserConstants.DELETE_USER_REQUEST_ERROR:
        draft.isLoading = false;
        draft.error = action.error;
        return draft;

      case DeleteUserConstants.DELETE_USER_REQUEST_FORCE_PAGE_RELOAD:
        return {
          ...state,
          forceReload: action.forceReload,
        };

      default:
        return state;
    }
  });
};

export default reducer;
